// extracted by mini-css-extract-plugin
export default {"readMoreLabel":"ReadMore_readMoreLabel__jbxS1","content":"ReadMore_content__s0TAL","expanded":"ReadMore_expanded__3019X"};